import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { popupTypes } from 'helpers/constants';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';

import { GeneralDialog, LoadingStatusWrapper } from 'sharedComponents';
import { getDefaultFilters } from '../GeneralFilter/GeneralFilterModal/helpers';
import { handleNotificationNavigation } from '../PowertrainOverview/Header/NotificationDropdown/helpers';

const SwitchOrganizationComponent = ({ ...props }) => {
    const { t: translate } = useTranslation();
    const history = useHistory();
    const { actions, model } = props;
    const notification = model.selectedNotification;
    const switchRequestRef = useRef(0);
    const closeModal = () => {
        actions.setShowSwitchOrgModal(false);
        history.push({
            pathname: history.location.pathname,
            search: history.location.search
        });
    };

    const handleSwitchOrganization = () => {
        if (notification) {
            const requestId = ++switchRequestRef.current;
            const selectedFilters = getDefaultFilters();
            const org = model.organizations.filter((org) => org.organizationId === notification?.organizationId);
            actions.setSelectedFilters({ ...selectedFilters, organizations: org });
            actions.setSelectedFiltersEdit({ ...selectedFilters, organizations: org });
            Promise.resolve(actions.saveFiltersWithSync()).then(() => {
                // SKIP NAVIGATION IF A NEWER SWITCH REQUEST STARTED WHILE THIS ONE WAS LOADING
                if (switchRequestRef.current === requestId) {
                    handleNotificationNavigation(notification, history);
                }
            });
            //readNotificationListAction is already called in closeNotification before showing the modal
        }
        closeModal();
    };

    return <GeneralDialog
        id='switch-organization-modal'
        show={model.showSwitchOrgModal}
        notificationType={popupTypes.INFO}
        closeButton={true}
        cancelButtonProps={{
            text: translate('ABB.Powertrain.Frontend.cancelLabel'),
        }}
        close={() => {
            closeModal();
        }}
        title={translate('ABB.Powertrain.Frontend.switchOrganizationTitle')}
        acceptButtonProps={{
            text: translate('ABB.Powertrain.Frontend.switchOrganizationTitle'),
            onClick: () => { handleSwitchOrganization(); }
        }}
    >
        <LoadingStatusWrapper>
            {translate('ABB.Powertrain.Frontend.switchOrganizationMsg')}
        </LoadingStatusWrapper>
    </GeneralDialog>;
};

SwitchOrganizationComponent.propTypes = {
    model: PropTypes.shape({
        showSwitchOrgModal: PropTypes.bool,
        selectedNotification: PropTypes.shape({
            organizationId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        }),
        organizations: PropTypes.array,
    }),
    actions: PropTypes.shape({
        setShowSwitchOrgModal: PropTypes.func,
        setSelectedFilters: PropTypes.func,
        setSelectedFiltersEdit: PropTypes.func,
        saveFiltersWithSync: PropTypes.func,
    }),
};

export default SwitchOrganizationComponent;
